import React, { ReactElement } from "react";
import { StyledPdfPage } from "./styled";

interface Props {
  QRComponent: ReactElement;
  title: string;
}

const PdfPage = React.forwardRef<HTMLDivElement, Props>(
  ({ QRComponent, title }, ref) => {
    return (
      <StyledPdfPage ref={ref}>
        <header>
          <h1>{title}</h1>
        </header>
        <div className="body-container">{QRComponent}</div>
        <footer>This page is machine generated</footer>
      </StyledPdfPage>
    );
  }
);

export default PdfPage;
